var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"aria-labelledby":_vm.iconName,"height":_vm.height,"width":_vm.width,"role":"presentation","viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}},[_c('title',{attrs:{"id":_vm.iconName,"lang":"en"}},[_vm._v(_vm._s(_vm.iconName))]),_vm._v(" "),_c('g',{attrs:{"fill":_vm.iconColor}},[_vm._t("default")],2)])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4c4b7852","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/V2/popup-chat/components/IconBase.vue
// module id = 6/ky
// module chunks = 0